import { render, staticRenderFns } from "./WholesalerList.vue?vue&type=template&id=41bba9f8&scoped=true"
import script from "./WholesalerList.vue?vue&type=script&lang=js"
export * from "./WholesalerList.vue?vue&type=script&lang=js"
import style0 from "./WholesalerList.vue?vue&type=style&index=0&id=41bba9f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bba9f8",
  null
  
)

export default component.exports